import CustomIdInput from './CustomIdInput';

export default CustomIdInput;
